import { getFunctions, httpsCallable } from 'firebase/functions';
import { app } from './firebaseConfig';

const functions = getFunctions(app, 'europe-west1');
const redeemFn = httpsCallable<{ code: string }, { email: string }>(functions, 'account-redeemLicence');

/**
 * Tells the server about codes redeemed on this phone (docs/plans/local-mode.md, Phase 3), so it
 * lets the email each was signed for create an account: the server, not the phone, has the last
 * word. Best effort and safe to repeat: offline, or for a code the server doesn't take, nothing
 * happens, and the next start tries again.
 */
export async function registerLicenceCodes(codes: string[]): Promise<void> {
  await Promise.all(
    codes.map((code) =>
      Promise.resolve()
        .then(() => redeemFn({ code }))
        .catch((error) => console.warn('Could not register a licence code with the server:', error)),
    ),
  );
}
